import { useApi } from '@/composables/useApi'

const api = useApi()

const PassWordService = {
  async ChangePassword(user_email) {
    return api.post('/redefirSenhaEmail', { user_email })
  },
  async resetPassword(token, password) {
    return api.post('/resetPassword', { token, password })
  },
}

export default PassWordService
